import myzxios from '../utils/myaxios'

export function getIndexData(data){
    return myzxios({
        url: '/manager/CardRoute/getIndexData',
        data,
        method: 'post'
    })
}


export function getIndexDataTM(data){
    return myzxios({
        url: '/manager/CardRoute/getIndexDataTM',
        data,
        method: 'post'
    })
}